import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-plum-deep px-5 py-14 sm:px-8 sm:py-16" data-id="element-99" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto flex max-w-2xl flex-col items-center gap-5 rounded-2xl border-2 border-gold/50 bg-plum p-6 text-center sm:flex-row sm:items-start sm:p-7 sm:text-left" data-id="element-100" data-mp="1o5zqy212ub4m">
        <ShieldCheckIcon className="h-14 w-14 shrink-0 text-gold" aria-hidden="true" strokeWidth={1.5} data-id="element-101" data-mp="1x54tdjfreom2" />
        <div data-id="element-102" data-mp="14g66k90oyyaf">
          <h2 className="font-display text-xl font-black uppercase tracking-wide text-gold sm:text-2xl" data-id="element-103" data-mp="14gforafhw15k">
            Garantía 7 Días — 100% Satisfacción
          </h2>
          <p className="mt-3 font-sans text-sm leading-relaxed text-cream/85 sm:text-base" data-id="element-104" data-mp="1edtzcteqlvpy">
            Probalo sin riesgo. Si al revisar el contenido sentís que la Guía DesbloqueARTE no es
            clara, útil o práctica para ayudarte a desbloquear tus emociones y que dejes de
            procrastinar, podés pedir la devolución dentro de los próximos 7 días.
          </p>
          <p className="mt-3 font-display text-base font-bold text-cream sm:text-lg" data-id="element-105" data-mp="oxf780y3m9oc">
            Sin vueltas. Sin complicaciones.
          </p>
          <p className="mt-3 font-sans text-xs uppercase tracking-[0.14em] text-cream/50" data-id="element-106" data-mp="yp2x3xf0binp">
            La decisión es tuya. El riesgo es nuestro.
          </p>
        </div>
      </div>
    </section>;
}